<template>
    <div>
        <LoaderSplash :loaded="loaded">
            <div v-if="invite">
                <b-navbar toggleable="md" class="navbar navbar-light" v-bind:style="{ 'background-color' : event.client.header_color }">
                    <div class="container">
                        <div class="row">
                            <b-navbar-brand class="col-md-3">
                                <router-link to="/">
                                    <img class="logo" v-bind:src="event.client.logo">
                                </router-link>
                            </b-navbar-brand>

                        </div>
                    </div>
                </b-navbar>

                <b-container v-if="loaded && invite" class="invite pt-5">
                    <b-row>
                        <b-col>
                            <div class="invite__header">
                                <h3 class="mb-0">
                                    You have been invited to
                                </h3>

                                <div class="divider divider--pink mt-4 mb-4" v-bind:style="{ 'border-color' : event.client.footer_color }"></div>

                                <h1 class="invite__event-name font-bold">
                                    {{ event.name }}
                                </h1>

                                <h1 class="invite__event-location mt-3">
                                    {{ addressFirstLine }}
                                </h1>

                                <h3 class="invite__event-day" v-bind:style="{ 'color' : event.client.footer_color }">
                                    {{ startDayString }}
                                </h3>

                                <div class="invite__event-image mt-5">
                                    <img v-bind:src="event.image">
                                </div>
                            </div>

                            <div class="invite__booking mt-5">
                                <div class="confirm-block">
                                    <div v-if="!show_booking_form">
                                        <h2 class="confirm-block__title mb-3">
                                            {{ CTAText }}
                                        </h2>

                                        <div class="confirm-block__buttons">
                                            <a href=""
                                               @click.prevent="attemptToConfirm()"
                                               class="confirm-block__button confirm-block__button--gold"
                                               v-bind:class="{ 'selected' : status == 'ACCEPTED' }">
                                                YES
                                                <span class="inline-fa confirm-block__status-check confirm-block__status-check--gold" v-if="status == 'ACCEPTED'">
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M413.505 91.951L133.49 371.966l-98.995-98.995c-4.686-4.686-12.284-4.686-16.971 0L6.211 284.284c-4.686 4.686-4.686 12.284 0 16.971l118.794 118.794c4.686 4.686 12.284 4.686 16.971 0l299.813-299.813c4.686-4.686 4.686-12.284 0-16.971l-11.314-11.314c-4.686-4.686-12.284-4.686-16.97 0z"/></svg>
                                                </span>
                                            </a>

                                            <a href=""
                                               @click.prevent="reject()"
                                               class="confirm-block__button confirm-block__button--blue"
                                               v-bind:class="{ 'selected' : status == 'REJECTED' }">
                                                NO
                                                <span class="inline-fa confirm-block__status-check confirm-block__status-check--blue" v-if="status == 'REJECTED'">
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M413.505 91.951L133.49 371.966l-98.995-98.995c-4.686-4.686-12.284-4.686-16.971 0L6.211 284.284c-4.686 4.686-4.686 12.284 0 16.971l118.794 118.794c4.686 4.686 12.284 4.686 16.971 0l299.813-299.813c4.686-4.686 4.686-12.284 0-16.971l-11.314-11.314c-4.686-4.686-12.284-4.686-16.97 0z"/></svg>
                                                </span>
                                            </a>
                                        </div>
                                    </div>

                                    <div v-else>
                                        <div class="confirm-block__booking">
                                            <h2 class="confirm-block__title">
                                                {{ BookingText }}
                                            </h2>

                                            <p class="confirm-block__subtitle">
                                                <a href="#" class="tb-table__button tb-table__button--blue tb-table__button--color-blue"
                                                   @click.prevent="hideBookingForm()">Or book another time</a>
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <transition name="slide-fade">
                                    <div v-if="show_booking_form" class="confirm-block__form">
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <div v-if="event.cost > 0">
                                                    <p class="confirm-block__form-heading">
                                                        There is a fee of £{{ event.cost }} to attend this event.
                                                    </p>

                                                    <div v-if="event.requires_payment_upfront">
                                                        <p class="confirm-block__form-heading">
                                                            Please provide payment details.
                                                        </p>

                                                        <div class="card-payment">
                                                            <p class="clear-fix"><i class="fas fa-lock"></i> Secure card payment
                                                                <img class="stripe-logo" src="@/assets/powered_by_stripe.svg">
                                                            </p>

                                                            <stripe :invite="invite"></stripe>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </transition>
                            </div>
                        </b-col>
                    </b-row>

                    <b-row v-if="event.cost >= 0 && event.requires_payment_upfront && status == 'ACCEPTED'" class="mt-4">
                        <b-col>
                            <div class="invite__payments" v-if="payment">
                                <div>
                                    <h3>
                                        You have paid for this event. Your payments:
                                    </h3>
                                </div>

                                {{ payment.updated_at }}.
                                <a v-if="payment.receipt_url" v-bind:href="payment.receipt_url" target="_blank">View your receipt</a>
                            </div>
                        </b-col>
                    </b-row>

                    <b-row v-if="status == 'ACCEPTED' && questions">
                        <b-col>
                            <div class="event-qa">
                                <div class="divider divider--blue divider--thin divider--full-width my-5" v-bind:style="{ 'border-color' : event.client.header_color }"></div>

                                <h2 class="mt-5 mb-3">
                                    Your Answers
                                </h2>

                                <p>
                                    Please answer the following questions.
                                </p>

                                <answerable-question-list
                                    :questions="questions"
                                    :answers="answers"
                                    @changed="(index, answer) => answerChanged(index, answer)">>
                                </answerable-question-list>

                                <button class="tb-table__button tb-table__button--blue tb-table__button--color-blue"
                                        @click="sendAnswers">
                                    Submit your answers
                                </button>
                            </div>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col>
                            <div class="event-info">
                                <div class="divider divider--blue divider--thin divider--full-width my-5" v-bind:style="{ 'border-color' : event.client.header_color }"></div>

                                <h2>
                                    About The Event
                                </h2>

                                <div v-html="event.description" class=""></div>
                            </div>
                        </b-col>
                    </b-row>

                    <b-row v-if="event.whatsapp_group_join_link">
                        <b-col>
                            <div class="divider divider--blue divider--thin divider--full-width mt-3 mb-5" v-bind:style="{ 'border-color' : event.client.header_color }"></div>

                            <h2>
                                Your WhatsApp group join link
                            </h2>

                            <p>
                                In order to join the WhatsApp group that will be used to manage this event,
                                please click this link on your phone or device.
                            </p>

                            <a v-bind:href="event.whatsapp_group_join_link">{{ event.whatsapp_group_join_link }}</a>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col>
                            <dropdown-container
                                class="mt-5 mb-3 dropdown-container--purple"
                                :open="containers.open.itinerary"
                                :heading="'ITINERARY'"
                                v-on:open-container="closeContainers(); containers.open.itinerary = true;"
                                v-on:close-container="closeContainers();">

                                <itinerary-display
                                    class="itinerary-display--purple"
                                    :days="event.days">
                                </itinerary-display>
                            </dropdown-container>

                            <dropdown-container
                                class="mb-3 dropdown-container--purple"
                                :open="containers.open.updates"
                                :heading="'UPDATES'"
                                v-on:open-container="closeContainers(); containers.open.updates = true;"
                                v-on:close-container="closeContainers();">

                                <div class="invite__updates">
                                    <div v-for="(update, index) in event.updates" :key="index">
                                        <update :update="update" class="invite__update update--purple"></update>
                                    </div>
                                </div>
                            </dropdown-container>

                            <dropdown-container
                                class="mb-3 dropdown-container--purple"
                                :open="containers.open.location"
                                :heading="'LOCATION'"
                                v-on:open-container="closeContainers(); containers.open.location = true;"
                                v-on:close-container="closeContainers();">

                                <b-row>
                                    <b-col xs="12" md="6">
                                        <ul class="address">
                                            <h1 class="font-italic">
                                                {{ split_address[0] }}
                                            </h1>

                                            <li class="address__line" v-for="address_line in split_address.slice(1)">
                                                {{ address_line }}
                                            </li>
                                        </ul>
                                    </b-col>

                                    <b-col xs="12" md="6">
                                        <gmap-map
                                            :center="map.reported_center"
                                            :zoom="12"
                                            ref="map"
                                            :class="map.class">
                                            <gmap-marker v-if="map.marker.position" :position="map.marker.position"></gmap-marker>
                                        </gmap-map>
                                    </b-col>
                                </b-row>

                            </dropdown-container>
                        </b-col>
                    </b-row>

                    <div class="divider divider--blue divider--thin divider--full-width mt-5 mb-3" v-bind:style="{ 'border-color' : event.client.footer_color }"></div>

                    <b-row>
                        <b-col>
                            <div class="sms-label mb-3" id="sms">
                                Receive SMS communications from Clubs Away
                            </div>

                            <checkbox
                                :initialvalue="invite.is_sms_opt_in"
                                @box-checked="toggleSmsOptIn">
                            </checkbox>
                        </b-col>
                    </b-row>
                </b-container>

                <signup-popup
                    v-if="invite && show_invite && !is_processing_payment"
                    :firstname="invite.first_name"
                    :lastname="invite.last_name"
                    :email="invite.email"
                    :eventid="invite.event_id"
                    :inviteid="invite.id"
                ></signup-popup>
            </div>

            <div v-else>
                <transition name="fade">
                    <div class="payment-processing-modal" v-show="is_processing_payment">
                        <h3>
                            Attempting to confirm payment...
                        </h3>
                    </div>
                </transition>
            </div>




        </LoaderSplash>



    </div>
</template>

<script>
    import moment from 'moment';
    import Update from '@/components/Update.vue';
    import AnswerableQuestionList from '@/components/AnswerableQuestionList.vue';
    import inviteRepository from "@/repository/invites";
    import DropdownContainer from "@/components/DropdownContainer";
    import ItineraryDisplay from "@/components/ItineraryDisplay";
    import SignupPopup from "@/components/SignupPopup";
    import Checkbox from "@/components/Checkbox";

    import Stripe from '@/components/Stripe.vue';

    const stripe_public_key = process.env.VUE_APP_STRIPE_KEY;
    export default {
        components: {
            AnswerableQuestionList,
            DropdownContainer,
            ItineraryDisplay,
            Update,
            SignupPopup,
            Stripe,
            Checkbox
        },

        props: ['id'],

        data(){
            return {
                STRIPE_REDIRECT_WAIT_SECONDS: 3000,
                //stripe stuff - move
                payment_details_complete: false,
                is_submitting:false,
                stripeOptions: {
                    // see https://stripe.com/docs/stripe.js#element-options for details
                },
                stripe_public_key,

                status: 'DEFAULT', // [DEFAULT, ACCEPTED, REJECTED]
                show_booking_form: false,

                loaded:false,
                invite:null,
                event:null,
                map: {
                    reported_center: {
                        lat: 1.32,
                        lng: 103.8
                    },
                    marker: {
                        position: false
                    },
                    class: "map-container",
                },
                questions: [],
                answers:[],
                containers: {
                    open: {
                        itinerary: true,
                        updates: false,
                        location: false,
                    }
                },
                is_processing_payment: false
            }
        },
        mounted() {
            this.loaded = true;
            this.onPageLoad();
            // inviteRepository.getByPublicUuid(
            //     this.id,
            //     {
            //         include: ['payments', 'event', 'answers', 'event.client', 'event.questions', 'event.updates', 'event.days', 'event.days.itinerary_items']
            //     }
            // ).then(res => {
            //     if (!res.data.event || !res.data.event.client) {
            //         this.$router.push('/invitee/invalid');
            //     }
            //
            //     this.invite = res.data;
            //     this.event = res.data.event;
            //     this.map.reported_center = {
            //         lat: this.event.address_lat,
            //         lng: this.event.address_lng
            //     }
            //     this.map.marker.position = {
            //         lat: this.event.address_lat,
            //         lng: this.event.address_lng
            //     }
            //     if(this.invite.status == 'ACCEPTED' || this.invite.status == 'REJECTED'){
            //         this.status = this.invite.status;
            //     }
            //     this.setQuestionsAnswers();
            //     this.loaded = true;
            //     this.afterLoadData();
            // }).catch(error => {
            //     this.$router.push('/invitee/invalid');
            // });
        },

        methods: {
            onPageLoad() {
                /**
                 * This page will get loaded in one of two ways - either the user will navigate to it,
                 * or Stripe will redirect them to it after payment.
                 *
                 * So we handle that here.
                 */

                var stripe_redirect = this.$route.query.redirect_status;

                console.log(stripe_redirect);

                /**
                 * Stripe redirect is detected. All this does right now is set this.is_processing_payment to true,
                 * which will display a 'processing your payment, please wait' overlay, and wait for 5 or so seconds
                 * before we grab the data. This is to handle an issue where sometimes Stripe was taking a long
                 * time to hit the payment api endpoint on our server, so a user would be redirected back here before
                 * we could confirm that their payment went through.
                 */

                // TODO: 'ACCEPTED' should be a const we define somewhere

                /**
                 * If we're redirected here from stripe and we haven't already accepted the payment,
                 * wait.
                 */
                if (stripe_redirect) {

                    console.log('In redirect');

                    // if payment failed, notify user
                    if (stripe_redirect !== 'succeeded') {
                        console.log('failed');

                        this.$notify({
                            group: 'main',
                            type: 'error',
                            title: 'Payment Unsuccessful',
                            text: 'There has been an error when paying with Stripe.',
                            duration: 10000
                        });

                        this.loadData();
                    } else {
                        console.log('succeeded');

                        this.loaded = true;
                        // this.$forceUpdate();
                        this.is_processing_payment = true;
                        // this.$forceUpdate();

                        setTimeout(() => {
                            console.log('in timeout function');

                            this.is_processing_payment = false;
                            this.loadData();
                        }, this.STRIPE_REDIRECT_WAIT_SECONDS);
                    }
                } else {

                    /**
                     * Otherwise, just load the data
                     */

                    this.loadData();
                }
            },

            loadData() {
                inviteRepository.getByPublicUuid(
                    this.id,
                    {
                        include: ['payments', 'event', 'answers', 'event.client', 'event.questions', 'event.updates', 'event.days', 'event.days.itinerary_items']
                    }
                ).then(res => {
                    if (!res.data.event || !res.data.event.client) {
                        this.$router.push('/invitee/invalid');
                    }

                    this.invite = res.data;
                    this.event = res.data.event;
                    this.map.reported_center = {
                        lat: parseFloat(this.event.address_lat),
                        lng: parseFloat(this.event.address_lng)
                    }
                    this.map.marker.position = {
                        lat: parseFloat(this.event.address_lat),
                        lng: parseFloat(this.event.address_lng)
                    }
                    if(this.invite.status == 'ACCEPTED' || this.invite.status == 'REJECTED'){
                        this.status = this.invite.status;
                    }
                    this.setQuestionsAnswers();
                    this.loaded = true;
                    // this.afterLoadData();
                }).catch(error => {
                    this.$router.push('/invitee/invalid');
                });
            },

            // afterLoadData() {
            //     // if we've redirected from stripe payment
            //     var stripe_redirect = this.$route.query.redirect_status;
            //
            //     if (!stripe_redirect || this.invite.status == 'ACCEPTED') return;
            //
            //     if (stripe_redirect == 'succeeded') {
            //         this.is_processing_payment = true;
            //
            //         setTimeout(() => {
            //             // this.confirm();
            //
            //             /**
            //              * On payment, user is redirected via Stripe to their bank's payment gateway.
            //              * On payment success or fail, they're redirected back here. At the same time,
            //              * Stripe will send a webhook to our API; if this webhook confirms the payment,
            //              * the API endpoint handler will set the invite status to 'ACCEPTED'. So in here,
            //              * we're going to wait for a few seconds, and then check to see if this has happened,
            //              * and if so, we'll update the frontend to reflect this
            //              *
            //              * TODO: this is not a particularly decent solution to this problem, because there's
            //              * now two completely separate ways for invites to be confirmed - one via an api call
            //              * from the frontend, for unpaid events; and one that occurs entirely via the Stripe webhook
            //              */
            //
            //             // get the invite after N seconds
            //             inviteRepository.getByPublicUuid(this.id, {
            //                 include: ['payments']
            //             })
            //             .then(res => {
            //                 var invite = res.data;
            //
            //                 // if its status has been set to accepted, update the frontend
            //                 if (invite.status === 'ACCEPTED') {
            //                     this.status = 'ACCEPTED';
            //                     this.invite.status = 'ACCEPTED';
            //                     this.invite.payments = invite.payments;
            //                 }
            //             });
            //
            //             this.is_processing_payment = false;
            //         }, 5000);
            //     } else {
            //         this.$notify({
            //             group: 'main',
            //             type: 'error',
            //             title: 'Payment Unsuccessful',
            //             text: 'There has been an error when paying with Stripe.',
            //             duration: 10000
            //         });
            //     }
            // },

            setQuestionsAnswers() {
                this.event.questions.forEach((question) => {
                    this.questions.push(question);

                    var answer = this.invite.answers.find((answer) => {
                        return answer.question_id == question.id
                    }) || {
                        text: ""
                    };

                    this.answers.push(answer);
                });
            },

            closeContainers() {
                this.containers.open.itinerary = false;
                this.containers.open.updates = false;
                this.containers.open.location = false;
            },

            viewed() {
                inviteRepository.viewed(this.invite.uuid)
                    .then(response => {
                        this.status = 'DEFAULT';
                    });
            },

            reject() {
                // a stopgap for now - you shouldn't be able to accept an event, pay for it, and then reject it,
                // because this would allow you to then click 'accept', which would open the booking form,
                // and allow you to pay twice.
                //
                // In future, we need to add a check to see if there's a payment for this invite, and if so
                // we need to just hide the booking form and say 'you've already paid' or something
                if (this.event.cost > 0 && this.status == 'ACCEPTED') return false;

                inviteRepository.reject(this.invite.uuid)
                    .then(response => {
                        this.status = 'REJECTED';
                    });
            },

            confirm() {
                inviteRepository.confirm(this.invite.uuid, {})
                    .then(response => {
                        console.log(response);
                        this.status = 'ACCEPTED';
                        this.invite.status = 'ACCEPTED';
                        this.hideBookingForm();

                        this.$notify({
                            group: 'main',
                            type: 'success',
                            title: 'Confirmation Successful',
                            text: 'You have successfully confirmed your attendance at this event.',
                            duration: 10000
                        });
                    }).catch(error => {
                        console.log(error.response.data.message);

                        this.$notify({
                            group: 'main',
                            type: 'error',
                            title: 'Unable to confirm payment',
                            text: error.response.data.message,
                            duration: 10000
                        });
                    })
            },

            sendAnswers() {
                var questions_answers = this.questions.map((x, i) => {
                    return { question: x, answer: this.answers[i] }
                });

                inviteRepository.sendAnswers(this.invite.uuid, {answers:questions_answers})
                    .then(response => {
                        this.$notify({
                            group: 'main',
                            type: 'success',
                            title: 'Answers Amended',
                            text: 'You have successfully amended your answers for this event.',
                            duration: 10000
                        });
                    }).catch(error => {

                    });
            },

            getDayString(day) {
                return moment(day.date).format("dddd Do MMMM");
            },

            answerChanged(index, answer) {
                this.answers[index].text = answer;
            },

            setStatus(status) {
                this.status = status;
            },

            attemptToConfirm() {
                if (this.status == 'ACCEPTED') return;

                // if card payment is requires now, show the form. else, just try to confirm
                if (this.event.cost > 0 && this.event.requires_payment_upfront) {
                    this.show_booking_form = true;
                } else {
                    this.confirm();
                }
            },

            hideBookingForm() {
                this.show_booking_form = false;
            },

            toggleSmsOptIn(opted_in) {
                if (opted_in) {
                    inviteRepository.smsOptIn(this.invite.uuid)
                        .then(response => {
                            this.invite.is_sms_opt_in = true;
                        })
                        .catch(error => {
                            this.$notify({
                                group: 'main',
                                type: 'error',
                                title: 'Error',
                                text: 'Unable to change your SMS preferences',
                                duration: 10000
                            });
                        })
                } else {
                    inviteRepository.smsOptOut(this.invite.uuid)
                        .then(response => {
                            this.invite.is_sms_opt_in = false;
                        })
                        .catch(error => {
                            this.$notify({
                                group: 'main',
                                type: 'error',
                                title: 'Error',
                                text: 'Unable to change your SMS preferences',
                                duration: 10000
                            });
                        })
                }
            }
        },
        computed:{
            payment() {
                return this.invite.payments.find((payment) => {
                   return (payment['status'] == 'PAID');
                });
            },

            show_invite() {
                // only show after the user has responded to the invite.
                // stop showing when they sign up.
                return !this.invite.has_signed_up && (this.status == 'ACCEPTED' || this.status == 'REJECTED');
            },

            split_address() {
                return this.event.address_address.split(",");
            },

            startDayString() {
                return moment(this.event.days[0].date).format("dddd Do MMMM")
            },

            addressFirstLine() {
                return this.event.address_address.split(",")[0];
            },

            CTAText(){
                return 'Will you be joining us?'
            },

            RejectedText(){
                return "We're sorry you can't make it"
            },

            BookingText() {
                return "To complete your booking, please fill in the form below"
            }
        }

    }
</script>

<style scoped lang="scss">
    .invite {

        &__event-name {
            text-transform: uppercase;
        }

        &__event-location {
            font-style: italic;
            font-weight: 200;
        }

        &__event-day {
            color: $color-pink;
        }

        &__event-image {
            @include media-breakpoint-down(md) {
                margin-left: -15px;
                margin-right: -15px;
            }

            img {
                width: 100%;
            }
        }

        &__booking {
            a {
                //color: $color-black;
                text-align: center;

                //&:hover {
                //    color: $color-black;
                //}
            }
        }

        &__updates > div:last-child > .invite__update {
            border: none;
        }
    }

    .confirm-block {
        //padding: 5rem 0;

        &__buttons {
            display: flex;
            flex: 1;
            justify-content: space-between;
            flex-direction: column;

            @include media-breakpoint-up(md) {
                flex-direction: row;
                margin: 0 -0.5rem;
            }
        }

        &__button:hover &__status-check {
            color: $color-white;
        }

        &__status-check {
            position: absolute;
            right: 1rem;
            top: 0.5rem;

            .inline-fa {
                font-size: 1rem;
            }

            &--gold {
                color: $color-gold;
            }

            &--blue {
                color: $color-light-blue;
            }
        }

        &__button.selected {
            cursor: auto;
        }

        &__button.selected &__status-check {
            color: $color-white;
        }

        &__button {
            position: relative;
            flex-grow: 1;
            @include font-h2;
            border: 2px solid;
            border-radius: 30px;
            color: $color-black;
            transition: 0.2s ease-in;
            padding: 0.5rem 1rem;
            margin: 0.5rem 0;

            @include media-breakpoint-up(md) {
                margin: 1rem 0.5rem;
            }

            &--blue {
                border-color: $color-light-blue;

                &:hover,
                &.selected{
                    background-color: $color-light-blue;
                    color: $color-white!important;
                }
            }

            &--gold {
                border-color: $color-gold;

                &:hover,
                &.selected {
                    background-color: $color-gold;
                    color: $color-white!important;
                }
            }

            &--black {
                border-color: $color-black;

                &:hover {
                    background-color: $color-black;
                    color: $color-white!important;
                }
            }
        }
    }

    .sms-label {
        //font-size: 14px;
    }

    .alt-checkbox {
        //float: left;
        //display: inline-block;
        //width: auto;
        //padding-top: 4px;
    }

    .card-payment{
        border:1px solid $color-light-blue;
        padding: 1rem;

        .stripe-logo{
            @media(min-width: 768px){
                float: right;
            }

        }
        .stripe-card {
            max-width: 520px;
            border: 1px solid #ced4da;
            padding: 0.5rem;
        }
        .stripe-card.complete {
            border-color: #28a745;
        }
    }
    .slide-fade-enter-active {
    transition: all .7s ease;
    }
    .slide-fade-leave-active {
    transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }
    .slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */ {
    transform: translateX(10px);
    opacity: 0;
    }

    .payment-processing-modal {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.9);
        color: $color-white;
        display: flex;
        align-items: center;
        flex-flow: column;
        justify-content: center;
        z-index: 9999;
    }

</style>